import { createFileRoute } from "@tanstack/react-router";

import { AccountScreen } from "@/interactors/AccountScreen";
import { headWithCustomTitle } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/account/")({
  component: AccountScreen,
  head: () => headWithCustomTitle("main:account.title"),
});
